import { Text, Flex, TextArea } from '@pega/cosmos-react-core';
import React, { useEffect, useState } from 'react';
import pretty from 'pretty';
import { useSelector } from 'react-redux';
import { appState } from '../../../../interfaces/common';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

interface ChatTagsProps {
  name: string;
  tag: string;
}

interface TagSnippetProps {
  currentTab: string;
  data?: any;
}

const TagSnippet: React.FC<TagSnippetProps> = ({ currentTab, data }) => {
  const { chatTags = [] } = useSelector((state: appState) => state.chatInfo);
  const [tagSnippet, setTagSnippet] = useState('');
  const translate = useLocalTranslation();

  useEffect(() => {
    if (currentTab === 'contextData') {
      let tempTagSnippet = `<script language="javascript">
          var PegaChatTags = {
              ${chatTags.map((tag: ChatTagsProps) => {
                return `"${tag.tag}":"{ ${translate('placeholder_for_customer_info')} }"`;
              })}
          }</script>`;
      setTagSnippet(pretty(tempTagSnippet));
    } else {
    }
  }, [chatTags, translate, currentTab]);

  const proactiveTriggerSnippet = `<script language="javascript">
    function () {
      PegaUnifiedChatWidget.triggerChat($trigger_code);
    } ()
  </script>`;

  const genAIFeedbackSnippet = `{
    "messages": "<Value of customer.messages>",
    "customerId": "<Value of customer.customerId>",
    "task": "<Value of customer.task>",
    "feedback": "<Value of customer.feedback>",
    "feedbackLanguage": "<Value of customer.feedbackLanguage>",
    "enableSendAgentFeedback": "<Value of customer.enableSendAgentFeedback>",
    "accountId": "<Value of customer.accountId>",
    "connectedAgentName": "<Value of customer.connectedAgentName>",
    "tokenUsage": "<Value of customer.tokenUsage>"
  }`;
  return (
    <Flex
      container={{
        direction: 'column',
        itemGap: 1,
      }}
    >
      <Text>
        {currentTab === 'genAIFeedback'
          ? translate('feedback_webhook_payload_text')
          : currentTab === 'contextData'
          ? translate('copy_tags_popup_snippet_title')
          : 'Trigger the chat by using triggerChat example provided below, you can input triggers added in proactive chat for the corresponding bot responses.'}
      </Text>
      <TextArea
        readOnly={true}
        style={{ minHeight: '10rem' }}
        value={
          currentTab === 'genAIFeedback'
            ? genAIFeedbackSnippet
            : currentTab === 'contextData'
            ? tagSnippet
            : proactiveTriggerSnippet
        }
      />
    </Flex>
  );
};

export default TagSnippet;
